import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import Select from 'components/select';
import { OrderPayload } from 'pages/myidm/store';

import { REQUEST_TYPE } from 'pages/myidm/utils/constant';

const REQUEST_TYPE_OPTIONS = [
    { label: REQUEST_TYPE.NEW, value: REQUEST_TYPE.NEW },
    { label: REQUEST_TYPE.MODIFY, value: REQUEST_TYPE.MODIFY },
    // { label: REQUEST_TYPE.DISABLE_GROUP, value: REQUEST_TYPE.DISABLE_GROUP },
];

export const TypeOfRequest = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);

    const handleOnSelectChange = (selected) => {
        setOrder({
            ...order,
            typeOfRequest: selected.value,
            groupType: null,
            modifyRequestType: null,
            domainType: null,
            adGroup: null,
            groupOwner: null,
            groupOwnerDetails: null,
            members: [],
            // New - AD Group
            multipleResourceGroups: [
                {
                    groupCategory: null,
                    groupSubCategory: null,
                    activeDirectoryGroupType: null,
                    domainType: null,
                    groupOwner: null,
                    groupName: null,
                    members: [],
                },
            ],
            // Modify - AD Group - Membership
            multipleAdGroups: [{ adGroup: null, adGroupOwner: null, members: [] }],
            // Modify - AD Group - Removal
            adGroupMembers: [],
        });
    };

    React.useEffect(() => {
        if (!order?.typeOfRequest && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.typeOfRequest, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                dataTestId="type-of-request-autocomplete"
                key="typeOfRequest"
                label="Type of Request *"
                value={order?.typeOfRequest || null}
                options={REQUEST_TYPE_OPTIONS}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(TypeOfRequest);
